import { AreaSequenceItemStatus } from '../interfaces/AreaSequenceItemStatus.enum';

export const isAsiComplete = (status: AreaSequenceItemStatus | undefined): boolean => {
	return status === AreaSequenceItemStatus.complete;
};
